module.exports = __webpack_public_path__ + "img/gu1chicun.f4bb4715.png";